<template>
	<v-dialog v-model="dialog" persistent max-width="380" scrollable>
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary">Pencarian Serial</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-text-field hide-details label="Serial" color="primary" v-model="params.serial.value"></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-autocomplete hide-details label="Status" no-data-text="Tidak ada data" color="primary" :items="used" item-text="text" item-value="value" v-model="params.isUsed.value"></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-menu v-model="buyDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Tanggal Pembelian" color="primary" class="input-regis" readonly v-bind="attrs" v-on="on" :value="convertDate(params.dateBuy.value)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="buyDate = false" v-model="params.dateBuy.value"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12">
							<v-menu v-model="useDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field hide-details label="Tanggal Digunakan" color="primary" class="input-regis" readonly v-bind="attrs" v-on="on" :value="convertDate(params.dateUse.value)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="useDate = false" v-model="params.dateUse.value"></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="py-4 justify-center">
				<v-col cols="4" class="py-0">
					<v-btn depressed block color="primary" class="white--text rounded-lg text-capitalize" :loading="btnLoading" :disabled="btnLoading" @click="cari">Cari</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			btnLoading: false,
			used: [
			{
				text: 'Belum Digunakan',
				value: '0'
			},
			{
				text: 'Sudah Digunakan',
				value: '1'
			}
			],
			buyDate: false,
			useDate: false,
			params: {
				serial: {
					type:'string',
					field:'serial_member_serial_id',
					value:''
				},
				isUsed: {
					type:'string',
					field:'serial_member_serial_is_used',
					value:''
				},
				dateBuy: {
					type:'string',
					field:'serial_member_serial_buy_datetime',
					value:''
				},
				dateUse: {
					type:'string',
					field:'serial_member_serial_used_datetime',
					value:''
				},
			},
		}
	},
	computed:{
	},
	props: {
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoading = false
			this.reset()
		},
		reset() {
			this.params.serial.value = ''
			this.params.isUsed.value = ''
			this.params.dateBuy.value = ''
			this.params.dateUse.value = ''
		},
		async cari() {
			if ( this.params.serial.value || this.params.isUsed.value || this.params.dateBuy.value || this.params.dateUse.value ) {
				this.btnLoading = await true
				await this.$emit('action', this.params)
			}
		},
	}
};
</script>